import axios from "axios";
import { encode as base64_encode } from "base-64";
import MaterialIcon from "material-icons-react";
import React from "react";
import { Button, Table } from "react-materialize";
import { retornarCookie } from "../../services/cookieservice";
import { ConfigurarSas } from "../../components/GatewaySas/GatewaySas";
import "./HomePage.css";
import Loader from "../../components/Loader/Loader";

const { REACT_APP_API, REACT_APP_URL_INSTANCE, REACT_APP_SAS_URL } =
  process.env;

export default class HomePage extends React.Component {
  state = {
    listaOportunidades: [],
    listaOportunidadesFiltro: [],
    exibeCarregamento: false,
    itemsPerPage: 15,
    currentPage: 1,
    tempoReloadGridSegundos: 30,
    exibeToastAtualizandoGrid: false,
  };

  componentDidMount() {
    this.trazerListaGrid(true);

    setInterval(() => {
      this.setState({ exibeToastAtualizandoGrid: true });
      this.trazerListaGrid(false);
    }, this.state.tempoReloadGridSegundos * 1000);
  }

  retornarInformacoesAgenteVenda = async (sessionId, cdAgenteVenda) => {
    const headers = { "Content-Type": "application/json" };
    const body = JSON.stringify({
      SessionID: sessionId,
      screenIdentification: "SASGC0065",
      Parameters: [
        {
          parametername: "cd_agentevenda",
          parametervalue: cdAgenteVenda,
        },
        {
          parametername: "idFilial",
          parametervalue: retornarCookie("IdUsuario"),
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers,
      body,
    };

    return await fetch(`${REACT_APP_SAS_URL}`, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        return result.responseJSONData.shift();
      });
  };

  trazerListaGrid = async (exibeLoader) => {
    if (exibeLoader === true){
      this.setState({ exibeCarregamento: true });
    }else{
      this.setState({ exibeToastAtualizandoGrid: true });
    } 

    ConfigurarSas().then((sessionId) => {
      this.retornarInformacoesAgenteVenda(
        sessionId,
        retornarCookie("CdAgenteVendas")
      ).then(async (agenteVenda) => {
        axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

        await axios
          .get(
            `${REACT_APP_API}oportunidade?IdAgenteVendas=` +
            agenteVenda.id_AgenteVenda
          )
          .then((res) => {
            const listaOportunidades = res.data;

            this.setState({ listaOportunidades });

            this.setState({ listaOportunidadesFiltro: listaOportunidades });

            this.setState({ exibeCarregamento: false });

            setTimeout(() => {
              this.setState({ exibeToastAtualizandoGrid: false });  
            }, 5000);  

          });
      });
    });
  };

  formatarCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[.\-/]/g, "").toUpperCase();
    return cnpj.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})$/,
      "$1.$2.$3/$4-$5"
    );
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  CopiarProposta = async (OportunidadeId) => {
    const redirectTo = base64_encode("NavigationBar,DadosEmpresaPage");

    document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
      retornarCookie("Auth")
    )}&MultiProposta=${OportunidadeId}`;
  };

  decisaoProposta = async (propostaId, decisao) => {
    const requestOptions = {
      method: "POST",
      redirect: "follow",
      mode: "no-cors",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    };

    return await fetch(
      `${REACT_APP_API}CotacaoPME/ImpressaoProposta?IdProposta=${propostaId}&Decisao=${decisao}`,
      requestOptions
    ).then((result) => {
      this.trazerListaGrid(false);
      return result;
    });
  };

  filtrar = (e) => {
    var filterValue = document.getElementById("SearchBar").value;

    if (document.getElementById("SearchBar").value !== "") {
      let FilteredListaOportunidade =
        this.state.listaOportunidadesFiltro.filter(
          (item) =>
            item.RazaoSocial.toString().toLowerCase().includes(filterValue.toString().toLowerCase()) ||
            item.PropostaId.toString().includes(filterValue.toString()) ||
            item.OportunidadeID.toString().includes(filterValue.toString()) ||
            item.Cnpj.toString().toUpperCase().includes(filterValue.toString().toUpperCase().replace(/[.\-/]/g, ""))
        );

      this.setState({ listaOportunidades: FilteredListaOportunidade });
      this.setState({ currentPage: 1 });
    }
  };

  isNivel2Opportunity = (oportunidade) => {
    const nivel = oportunidade?.NivelOportunidade ?? oportunidade?.nivelOportunidade;
    if (Number(nivel) === 2) {
      return true;
    }

    const qtdeVidas = Number(oportunidade?.QtdeVidas ?? oportunidade?.qtdeVidas ?? 0);
    return qtdeVidas >= 30 && qtdeVidas <= 99;
  };

  carregarOportunidadePorId = async (oportunidadeId) => {
    const params = {
      oportunidadeID: oportunidadeId,
      IdAgenteVendas: retornarCookie("IdAgenteVenda"),
      CdAgenteVendas: retornarCookie("CdAgenteVendas"),
      multiplasPropostas: false,
    };

    const res = await axios.get(`${REACT_APP_API}oportunidade/OportunidadePorId`, {
      params,
    });

    return res.data;
  };

  ContinuarProposta = async (Etapa, OportunidadeID, oportunidadeGrid) => {
    let redirectTo = "";
    var redirectHomePage = false;

    try {
      let oportunidade = oportunidadeGrid;
      if (!oportunidade || (!oportunidade.NivelOportunidade && !oportunidade.QtdeVidas)) {
        oportunidade = await this.carregarOportunidadePorId(OportunidadeID);
      }

      if (this.isNivel2Opportunity(oportunidade)) {
        redirectTo = base64_encode("NavigationBar,InformacoesNivel2Page");
        document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
          retornarCookie("Auth")
        )}&OportunidadeID=${OportunidadeID}`;
        return;
      }
    } catch (e) {
      // Keep legacy etapa routing when details cannot be loaded.
    }

    switch (Etapa) {
      case 2:
        try {
          let oportunidade = oportunidadeGrid;
          if (!oportunidade || (!oportunidade.NivelOportunidade && !oportunidade.QtdeVidas)) {
            oportunidade = await this.carregarOportunidadePorId(OportunidadeID);
          }

          const isNivel2 = this.isNivel2Opportunity(oportunidade);
          redirectTo = base64_encode(
            isNivel2 ? "NavigationBar,InformacoesNivel2Page" : "NavigationBar,ElegibilidadePage"
          );
        } catch (e) {
          redirectTo = base64_encode("NavigationBar,ElegibilidadePage");
        }
        break;
      case 3:
        redirectTo = base64_encode("NavigationBar,ElegibilidadePage");
        break;

      default:
        redirectTo = base64_encode("NavigationBar,HomePage");
        redirectHomePage = true;
        break;
    }

    if (redirectHomePage) {
      document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
        retornarCookie("Auth")
      )}`;
    } else {
      document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
        retornarCookie("Auth")
      )}&OportunidadeID=${OportunidadeID}`;
    }
  };

  RemoverProposta = (OportunidadeId) => {
    this.setState({ exibeCarregamento: true });
    if (
      window.confirm("Tem certeza que deseja cancelar esta oportunidade?") ==
      true
    ) {
      axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
      axios
        .put(`${REACT_APP_API}oportunidade/Delete/${OportunidadeId}`)
        .then((res) => {
          this.trazerListaGrid(false);
        });
    } else {
      this.trazerListaGrid(false);
    }
  };

  AprovarProposta = (PropostaId) => {
    if (
      window.confirm(
        "Tem certeza que deseja aprovar a proposta " + PropostaId + "?"
      )
    )
      this.decisaoProposta(PropostaId, true);
  };

  RecusarProposta = (PropostaId) => {
    if (window.confirm("Tem certeza que deseja recusar a oportunidade ?"))
      this.decisaoProposta(PropostaId, false);
  };

  NovaOportunidade = () => {
    const redirectTo = base64_encode("NavigationBar,DadosEmpresaPage");

    document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
      retornarCookie("Auth")
    )}`;
  };

  RedirecionarProposta = (urlProposta) => {
    window.open(urlProposta, "_blank");
  };

  VerificarDataPropostaProcessamento = (Data) => {
    const data = new Date(Data);
    if (data.getTime() >= new Date().getTime() - 60 * 60 * 1000) {
      return true;
    } else {
      return false;
    }
  };

  formatarData = (data) => {
    const date = new Date(data);
    const output = date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return output;
  };

  formatarStatus = (status) => {
    const estados = {
      0: "Cadastro",
      1: "Negociacao",
      3: "Ganha",
      4: "Implantada",
      5: "Perdida",
    };
    const estadoString = estados[parseInt(status)];
    return estadoString || status;
  };

  getTotalPages = () => {
    const { listaOportunidades, itemsPerPage } = this.state;
    return Math.ceil(listaOportunidades.length / itemsPerPage);
  };

  getCurrentPageItems = () => {
    const { listaOportunidades, currentPage, itemsPerPage } = this.state;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return listaOportunidades.slice(startIndex, endIndex);
  };

  render() {

    return (
      <div className="fade-in">
        {this.state.exibeToastAtualizandoGrid &&
          <span className="ToastAtualizando">
            Atualizando oportunidades ...
          </span>}
        {this.state.exibeCarregamento && <Loader />}
        <div className="row container">
          <div className="col s8 m8 l8">
            <br />
            <b>
              <h5>Histórico de oportunidades</h5>
            </b>
            Revise seu histórico, acompanhe os status das suas vendas e inicie
            novas oportunidades.
          </div>

          <div className="col s4 m4 l4 right-align">
            <br />
            <button
              type="button"
              className="OmintButton "
              onClick={() => { this.NovaOportunidade() }}
            >
              Nova Oportunidade
            </button>
          </div>

          <div className="col s6 m6 l6">
            <br />
            <input
              type="text"
              placeholder="Pesquisar"
              className="SearchBar"
              id="SearchBar"
              name="SearchBar"
              onChange={() => {
                this.filtrar();
              }}
            />
          </div>
        </div>

        <div className="row container">
          <Table className="centered">
            <thead>
              <tr>
                <th data-field="Oportunidade">Id</th>
                <th data-field="OportunidadeCRM">Oportunidade</th>
                <th data-field="Proposta">Proposta</th>

                <th data-field="CNPJ">CNPJ</th>

                <th data-field="Nome">Nome</th>

                <th data-field="DataCriacao">Data de Criação</th>

                <th data-field="Fase">Fase</th>

                <th className="thAcao">Ação</th>
              </tr>
            </thead>
            <tbody>
              {this.getCurrentPageItems().map((Oportunidade) => (
                <tr>
                  <td>{Oportunidade.OportunidadeID}</td>
                  <td>
                    {Oportunidade.OportunidadeID_CRM
                      ? Oportunidade.OportunidadeID_CRM
                      : "-"}
                  </td>
                  <td>
                    {Oportunidade.PropostaId ? Oportunidade.PropostaId : "-"}
                  </td>
                  <td>{this.formatarCNPJ(Oportunidade.Cnpj)}</td>
                  <td>{Oportunidade.RazaoSocial.toString().toUpperCase()}</td>
                  <td>{this.formatarData(Oportunidade.DataCriacao)}</td>
                  <td>{this.formatarStatus(Oportunidade.Status)}</td>
                  <td className="GridIconBar">
                    {!this.VerificarDataPropostaProcessamento(
                      Oportunidade.DataCriacao
                    ) &&
                      Oportunidade.Status === 1 &&
                      !Oportunidade.UrlPDFProposta && (
                        <b>
                          <Button
                            node="button"
                            tooltip={
                              "Entre em contato com o seu consultor Omint para mais informações"
                            }
                            tooltipOptions={{ position: "top" }}
                            className="gridIcon"
                          >
                            <MaterialIcon icon="highlight_off" color="red" />
                          </Button>
                        </b>
                      )}
                    {this.VerificarDataPropostaProcessamento(
                      Oportunidade.DataCriacao
                    ) &&
                      Oportunidade.Status === 1 &&
                      !Oportunidade.UrlPDFProposta && (
                        <Button
                          node="button"
                          tooltip={"Processando..."}
                          tooltipOptions={{ position: "top" }}
                          className="gridIcon"
                        >
                          <div className="loader"></div>
                        </Button>
                      )}
                    {Oportunidade.Status !== 1 &&
                      !Oportunidade.PropostaGerada && (
                        <b>
                          <Button
                            node="button"
                            tooltip={"Continuar"}
                            tooltipOptions={{ position: "top" }}
                            className="gridIcon"
                            onClick={() => {
                              this.ContinuarProposta(
                                Oportunidade.UltimoEstagio + 1,
                                Oportunidade.OportunidadeID,
                                Oportunidade
                              );
                            }}
                          >
                            <MaterialIcon icon="rotate_right" color="#172972" />
                          </Button>
                        </b>
                      )}

                    {Oportunidade.UrlPDFProposta &&
                      !Oportunidade.CotacaoDataAceite &&
                      !Oportunidade.CotacaoDataRecusado && (
                        <b>
                          <Button
                            node="button"
                            tooltip="Copiar Proposta"
                            tooltipOptions={{ position: "top" }}
                            className="gridIcon"
                            onClick={() => {
                              this.CopiarProposta(Oportunidade.OportunidadeID);
                            }}
                          >
                            <MaterialIcon icon="content_copy" color="#172972" />
                          </Button>
                        </b>
                      )}

                    {Oportunidade.UrlPDFProposta && (
                      <b>
                        <Button
                          node="button"
                          tooltip="Visualizar"
                          tooltipOptions={{ position: "top" }}
                          className="gridIcon"
                          onClick={() => {
                            this.RedirecionarProposta(
                              Oportunidade.UrlPDFProposta
                            );
                          }}
                        >
                          <MaterialIcon icon="remove_red_eye" color="#172972" />
                        </Button>
                      </b>
                    )}
                    {Oportunidade.Status !== 1 &&
                      !Oportunidade.PropostaGerada && (
                        <b>
                          <Button
                            node="button"
                            tooltip="Remover"
                            tooltipOptions={{ position: "top" }}
                            className="gridIcon"
                            onClick={() => {
                              this.RemoverProposta(Oportunidade.OportunidadeID);
                            }}
                          >
                            <MaterialIcon icon="delete_forever" color="red" />
                          </Button>
                        </b>
                      )}
                    {Oportunidade.UrlPDFProposta &&
                      !Oportunidade.CotacaoDataAceite &&
                      !Oportunidade.CotacaoDataRecusado && (
                        <b>
                          <Button
                            node="button"
                            tooltip="Aprovar"
                            tooltipOptions={{ position: "top" }}
                            className="gridIcon"
                            onClick={() => {
                              this.AprovarProposta(Oportunidade.PropostaId);
                            }}
                          >
                            <MaterialIcon icon="thumb_up" color="#0fbf0f" />
                          </Button>
                        </b>
                      )}
                    {Oportunidade.UrlPDFProposta &&
                      !Oportunidade.CotacaoDataAceite &&
                      !Oportunidade.CotacaoDataRecusado && (
                        <b>
                          <Button
                            node="button"
                            tooltip="Recusar"
                            tooltipOptions={{ position: "top" }}
                            className="gridIcon"
                            onClick={() => {
                              this.RecusarProposta(Oportunidade.PropostaId);
                            }}
                          >
                            <MaterialIcon icon="thumb_down" color="red" />
                          </Button>
                        </b>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="pagination">
            <button
              className="OmintButtonSmall"
              onClick={() =>
                this.setState((prevState) => ({
                  currentPage: Math.max(prevState.currentPage - 1, 1),
                }))
              }
              disabled={this.state.currentPage === 1}
            >
              {"<"}
            </button>
            <span className="PaginationPageCounter">
              Página <b className="BlueText">{this.state.currentPage}</b> de <b className="BlueText">{this.getTotalPages()}</b>
            </span>
            <button
              className="OmintButtonSmall"
              onClick={() =>
                this.setState((prevState) => ({
                  currentPage: Math.min(
                    prevState.currentPage + 1,
                    this.getTotalPages()
                  ),
                }))
              }
              disabled={this.state.currentPage === this.getTotalPages()}
            >
              {">"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
